import React from 'react';
import { StatusIcon } from './layout/StatusIcon';
import './ActivationLoading.css';

export interface ActivationLoadingProps {
  cardId: string;
  title?: string;
  message?: string;
  progressText?: string;
  statusLabel?: string;
  footerText?: string;
}

const DEFAULT_TITLE = 'Activating Your Card';
const DEFAULT_MESSAGE = 'Please wait while we securely activate your card...';
const DEFAULT_PROGRESS_TEXT = 'Processing';
const DEFAULT_STATUS_LABEL = 'Activating';
const DEFAULT_FOOTER_TEXT = 'Securing your card...';

const ActivationLoading: React.FC<ActivationLoadingProps> = ({
  cardId,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  progressText = DEFAULT_PROGRESS_TEXT,
  statusLabel = DEFAULT_STATUS_LABEL,
  footerText = DEFAULT_FOOTER_TEXT,
}) => {
  return (
    <div className="activation-loading" data-testid="activation-loading">
      <StatusIcon variant="loading" className="activation-icon-wrap" />
      <h2 className="activation-title">{title}</h2>
      <p className="activation-message">{message}</p>

      <div className="progress-section">
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
        <div className="progress-text">{progressText}</div>
      </div>

      <div className="activation-details">
        <div className="detail-item">
          <span className="detail-label">Card ID:</span>
          <span className="detail-value">{cardId}</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Status:</span>
          <span className="detail-value">{statusLabel}</span>
        </div>
      </div>

      <div className="loading-animation">
        <div className="spinner"></div>
        <p>{footerText}</p>
      </div>
    </div>
  );
};

export default ActivationLoading;
